import { userProfileHttpClient } from '@/api/userProfile/client';
import { UserProfileDto, UserProfileBase, ProfileType } from '@/models';

export const UserApiService = {
  getUser: (id: string) => userProfileHttpClient.get(`/users/${id}/data`),
  createUser: (newUserData: Partial<UserProfileBase>) =>
    userProfileHttpClient.post(`/users/${newUserData.userId}/data`, newUserData),
  deleteUser: (id: string) => userProfileHttpClient.delete(`/users/${id}/data`),
  updateUser: (updatedUser: Partial<UserProfileDto>, userId: string) =>
    userProfileHttpClient.patch(`/users/${userId}/data`, updatedUser),
  addRecentlyViewed: (profileBk: string, userId: string, profileType: ProfileType) =>
    userProfileHttpClient.post(`/users/${userId}/recently-viewed`, { profileBk, profileType }),
};
